import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";
import * as _ from "lodash";
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IListItem, ISwapQualityIssue, ISwapQualityIssueCounts, ISwapQualityIssueForList } from "@nkr/models/index";
import { IGet, IPost } from '../authorization/index';
import { SwapQualityIssueListType } from '@nkr/enums/swap-quality-issue-list-type';

// action types

export const ActionTypes = {
    // SET_SWAP_QUALITY_ISSUE_REPORT: "SET_SWAP_QUALITY_ISSUE_REPORT",
    // SET_BILLING_REPORT: "SET_BILLING_REPORT",
    // SET_BILLING_PREPARATION_REPORT: "SET_BILLING_PREPARATION_REPORT"
}

// state interface

export interface ISwapQualityIssueState {
}

// action interfaces

export interface ISwapQualityIssueListResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapQualityIssueForList[]
    }
}

export interface ISwapQualityIssueResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapQualityIssue
    }
}

export interface ISwapQualityLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            swapQualityIssueTypes: IListItem[]
        }
    }
}

export interface ISwapQualityIssueCountResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapQualityIssueCounts
    }
}

export interface ISwapQualityIssueRequest {
    swapQualityIssueTypes: number[],
    requestInvestigation: number,
    issueDescription: string,
    rootCause: string,
    correctiveAction: string,
    surgicalAssistants: string,
    didSurgeonDiscussion: number,
    preSurgicalDiscussionDetails: string,
    postSurgicalDiscussionDetails: string,
    haveOrganQualityConcerns: number,
    organQualityConcernDetails: string,
    didOrganFunctionImmediately: number,
    isOrganCurrentlyFunctioning: number,
    doesPatientRequireReplacementKidney: number,
    donorWhyWasKidneyLate: string,
    administrativeNotes: string,
    isFinalized: boolean,

    photo1: File,
    removePhoto1: boolean,

    photo2: File,
    removePhoto2: boolean,

    photo3: File,
    removePhoto3: boolean,
}

export const ActionCreators = {
    getCounts: (centerId: number, reportedBy: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityIssueCountResponse> => {
        let options = {
            url: `${__API__}/swap-quality-issue/counts?centerId=${centerId}&reportedBy=${reportedBy}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getSwapQualityIssues: (centerId: number, listType: SwapQualityIssueListType, reportedBy: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityIssueListResponse> => {
        let options = {
            url: `${__API__}/swap-quality-issue/by-center?centerId=${centerId}&listType=${listType}&reportedBy=${reportedBy}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getById: (id: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityIssueResponse> => {
        let options = {
            url: `${__API__}/swap-quality-issue/${id}?centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityLookupDataResponse> => {
        let options = {
            url: `${__API__}/swap-quality-issue/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    save: (issueId: number, centerId: number, request: ISwapQualityIssueRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let formData = new FormData();

        for (let i = 0; i < request.swapQualityIssueTypes.length; i++) {
            formData.append('swapQualityIssueTypes[]', request.swapQualityIssueTypes[i].toString());
        }

        if (request.swapQualityIssueTypes.length == 0) {
            formData.append('swapQualityIssueTypes[]', [].toString());
        }

        formData.append('requestInvestigation', request.requestInvestigation.toString());
        formData.append('issueDescription', request.issueDescription);
        formData.append('rootCause', request.rootCause);
        formData.append('correctiveAction', request.correctiveAction);
        formData.append('surgicalAssistants', request.surgicalAssistants);
        formData.append('didSurgeonDiscussion', request.didSurgeonDiscussion.toString());
        formData.append('preSurgicalDiscussionDetails', request.preSurgicalDiscussionDetails);
        formData.append('postSurgicalDiscussionDetails', request.postSurgicalDiscussionDetails);
        formData.append('haveOrganQualityConcerns', request.haveOrganQualityConcerns.toString());
        formData.append('organQualityConcernDetails', request.organQualityConcernDetails);
        formData.append('didOrganFunctionImmediately', request.didOrganFunctionImmediately.toString());
        formData.append('isOrganCurrentlyFunctioning', request.isOrganCurrentlyFunctioning.toString());
        formData.append('doesPatientRequireReplacementKidney', request.doesPatientRequireReplacementKidney.toString());
        formData.append('isFinalized', request.isFinalized.toString());
        formData.append('donorWhyWasKidneyLate', request.donorWhyWasKidneyLate);
        formData.append('administrativeNotes', request.administrativeNotes);

        formData.append('photo1', request.photo1);
        formData.append('removePhoto1', request.removePhoto1.toString());

        formData.append('photo2', request.photo2);
        formData.append('removePhoto2', request.removePhoto2.toString());

        formData.append('photo3', request.photo3);
        formData.append('removePhoto3', request.removePhoto3.toString());

        var config: IPost = {
            url: `${__API__}/swap-quality-issue/save?issueId=${issueId}&centerId=${centerId}`,
            data: formData
        };

        return dispatch(AuthActionCreators.apiPostFormData(config)).then((response: IBaseResponse) => {
            return response;
        });
    },
    reopen: (issueId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let config: IPost = {
            url: `${__API__}/swap-quality-issue/${issueId}/reopen?centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiPost(config));
    },
    recordNoIssues: (issueId: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let config: IPost = {
            url: `${__API__}/swap-quality-issue/${issueId}/no-issues?centerId=${centerId}`
        };

        return await dispatch(AuthActionCreators.apiPost(config));
    }
}

// reducer creation

var initialState: ISwapQualityIssueState = {

}

const createReducer = (initialState: ISwapQualityIssueState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
}

export const Reducer = createReducer(initialState, handlers);